import { render, staticRenderFns } from "./TransferNetPrice.vue?vue&type=template&id=2bd32301&"
import script from "./TransferNetPrice.vue?vue&type=script&lang=js&"
export * from "./TransferNetPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports